module.exports = __webpack_public_path__ + "img/poo-bolt.309d2db5.svg";